<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eTaham/tc-custom/9781534469044.jpg?1730517180439" alt="This image is the cover for the book Naptime in the Neighborhood, Daniel Tiger's Neighborhood"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Naptime in the Neighborhood, Daniel Tiger's Neighborhood
      </h1>
      <p class="bookDescription body article font2">
        <b>A new generation of children love <i>Daniel Tiger’s Neighborhood</i>, inspired by the classic series <i>Mister Rogers’ Neighborhood</i>!</b><br/><br/><b>Daniel Tiger learns to wind down before naptime in this 8x8 storybook—a must-have Daniel Tiger first experiences book for parents and caregivers based on an all-new episode from the hit PBS show, <i>Daniel Tiger’s Neighborhood</i>!</b><br/><br/>It’s quiet time at school, but Daniel and Miss Elaina don’t want to stop playing with their trains! Teacher Harriet shows the kids the different ways they can settle down, like stretching, reading a book, or closing their eyes. Could it be that naptime is just what Daniel needs to be reenergized for more playing? He might even be able to use his new skills at home to help his baby sister fall asleep for naptime. <br/><br/>© 2020 The Fred Rogers Company
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alexandra Cassel Schwartz
      </h2>
      
      <p class="authorDescription body article">Alexandra Cassel Schwartz is the author of many books for children, including&#160;<I>Daniel Loves Playtime!</I>, a Simon &amp; Schuster book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon Spotlight
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e791f00